module.exports = __webpack_public_path__ + "static/media/morphos_sound_architecture.0da6265a.svg";